import { addMinutes, format, parseJSON } from "date-fns";
import returnMessageClass from "src/data/system/returnMessageClass";
import { differenceInCalendarDays } from "date-fns";

// export function hashCode(str) {
//   try {
//     if (str == null || str == "") return 0;
//     let hash = 0;
//     for (let i = 0; i < str.length; ++i) hash = Math.imul(31, hash) + str.charCodeAt(i);
//     return hash | 0;
//   } catch (err) {
//     console.log(err);
//     return null;
//   }
// }
export function hashCode(str) {
  if (!str) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; ++i) {
    hash = Math.imul(31, hash) + str.charCodeAt(i);
  }
  return hash | 0;
}

export function scroll6IfTop() {
  setTimeout(() => {
    if (window.scrollY === 0) {
      document.getElementById("logoDiv").scrollIntoView({ behavior: "smooth" });
    }
  }, 10);
}

export function getFirstNameLastNameFromString(stringText) {
  if (typeof stringText !== "string") {
    throw new Error("Input must be a string");
  }

  const isValidEmail = isEmail(stringText); // Checks if the input is a valid email
  let domain = "";
  let localPart = stringText.trim(); // Local part will be used as name if valid email

  if (isValidEmail) {
    const [local, domainPart] = stringText.split("@");
    localPart = local;
    domain = domainPart || ""; // Safeguard against undefined domain
  }

  const nameParts = localPart.split(/[ ,.]+/);
  const firstName = nameParts.length > 0 ? nameParts[0] : "";
  const lastName = nameParts.length > 1 ? nameParts[1] : "";

  return { firstName, lastName, domain };
}

export async function checkResponse(response, origin = "checkResponse") {
  const returnMessage = new returnMessageClass(origin);
  const msg = { success: false, data: null, errorMessage: "", returnMessage };

  try {
    msg.data = await response.json();
  } catch (err) {
    console.log(err);
    console.trace();
    msg.data = err;
    msg.success = response.success || false;
  }

  if (!response.ok) {
    msg.success = false;
    msg.errorMessage = msg.data?.originalError?.info?.message || "Virhe";
    returnMessage.message = msg.errorMessage;
    returnMessage.success = false;
    returnMessage.error = msg.data;
  } else {
    msg.success = true;
    returnMessage.message = "checkResponse: response.ok";
    returnMessage.success = true;
  }
  returnMessage.data = msg.data;
  return msg;
}
export function buildOsoite(tyomaa) {
  let osoite = "";
  if (!tyomaa) return osoite;
  if (tyomaa.tyomaaOsoite1) osoite += tyomaa.tyomaaOsoite1 + ", ";
  if (tyomaa.tyomaaOsoite2) osoite += tyomaa.tyomaaOsoite2 + " ";
  if (tyomaa.tyomaaOsoite3) osoite += tyomaa.tyomaaOsoite3 + " ";
  if (tyomaa.tyomaaOsoite4) osoite += tyomaa.tyomaaOsoite4;
  return osoite;
}

export const isNumber = (value) => {
  if (value == null) return false;
  if (typeof value === "number") return true;
  if (typeof value === "string") {
    if (value.trim() === "") return false;
    return !isNaN(value);
  }
  return false;
};

export const parseJSONDate = (JSONDate) => {
  if (!JSONDate) return null;
  const parsedDate = JSONDate instanceof Date && !isNaN(JSONDate) ? JSONDate : parseJSON(JSONDate);
  return parsedDate instanceof Date && !isNaN(parsedDate) ? parsedDate : null;
};

export const formatHinta = (hinta, showEur = false, yksikko = null) => {
  try {
    if (!hinta) return "";
    if (typeof hinta === "string") {
      hinta = hinta.replace(",", ".");
      hinta = parseFloat(hinta);
    }
    if (typeof hinta !== "number") return hinta;
    let result = hinta.toFixed(2).replace(".", ",");
    if (showEur) result += " €";
    if (yksikko) result += "/" + yksikko;
    return result;
  } catch (err) {
    console.log(err);
    return hinta;
  }
};

export function formattedPhoneString(phoneString) {
  try {
    phoneString = phoneString.replaceAll(" ", "");
    return `${phoneString.slice(0, 3)} ${phoneString.slice(3, 6)} ${phoneString.slice(6)}`;
  } catch {
    return phoneString || "";
  }
}

export function intlPhoneString(phoneString) {
  return phoneString.startsWith("+")
    ? phoneString
    : `+358${phoneString.startsWith("0") ? phoneString.substring(1) : phoneString}`;
}
export function aikaPvmStringLong(aika, noWeekDay = false) {
  if (aika == null) aika = new Date();
  try {
    if (isValidDate(aika)) {
      const vk = viikonpv(aika);
      const pvm = pvmStringLong(aika);
      const klo = kloString(aika);
      return (!noWeekDay ? vk + " " : "") + pvm + " " + klo;
    } else {
      return { aika } + " ei ole aika";
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

export function convertMinutesToHoursAndMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours > 0 ? hours + "h " : ""}${remainingMinutes > 0 ? remainingMinutes + "min" : ""}`;
}

export function pvmString(aika) {
  return isValidDate(aika) ? format(aika, "d.M") : "";
}
export function isEmail(value) {
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isEmail = re.test(value);
  return isEmail;
}

export function isValidDate(date) {
  try {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
  } catch {
    return false;
  }
}

export function getYYYYMMDD(date) {
  if (!date) return null;
  if (!isValidDate(date)) return null;
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return year * 10000 + month * 100 + day;
}

export function yyyymmddhhmm(date) {
  if (!date) return null;
  if (!isValidDate(date)) return null;
  return date
    .toISOString()
    .substring(0, 16)
    .replaceAll("-", "")
    .replaceAll("T", "")
    .replaceAll(":", "");
}

export function hhmm(aika) {
  if (!isValidDate(aika)) return null;
  return format(aika, "HHmm");
}

export function pvmStringLong(aika, preZero = false) {
  try {
    if (!isValidDate(aika)) return null;
    if (preZero) return aika ? format(aika, "dd.MM.yyyy") : "aika=null2";
    return aika ? format(aika, "d.M.yyyy") : "aika=null2";
  } catch {
    return "";
  }
}
export function kloString(aika) {
  try {
    if (!isValidDate(aika)) return null;
    return aika ? format(aika, "HH:mm") : "aika=null3";
  } catch (err) {
    console.log(err);
    return null;
  }
}

export function aikaStringLong(aika) {
  try {
    if (!isValidDate(aika)) return null;
    return aika ? format(aika, "d.M.yyyy HH:mm") : "aika=nullx";
  } catch {
    return "";
  }
}

export function aikaStringShort(aika) {
  try {
    if (!isValidDate(aika)) return null;
    const pvm = pvmString(aika);
    const klo = kloString(aika);
    return pvm + " " + klo;
  } catch (err) {
    console.log(err);
    return null;
  }
}

//palauttaa esim 12:00-17:00
export function kestoString(aika, kesto) {
  try {
    if (!isValidDate(aika)) return "";
    if (kesto == null || kesto == 0) return "";

    if (aika && kesto > 0) {
      const toKlo = addMinutes(aika, kesto);
      return format(aika, "HH:mm") + "-" + format(toKlo, "HH:mm");
    } else {
      return aika ? format(aika, "HH:mm") : "";
    }
  } catch (err) {
    console.log(err);
    return "pvmKestoString";
  }
}

export function tänäänHuomennaEilen(date) {
  if (!isValidDate(date)) return "";

  try {
    const today = new Date();
    const dayDiff = differenceInCalendarDays(date, today);

    switch (dayDiff) {
      case 0:
        return "Tänään"; // same calendar day
      case 1:
        return "Huomenna"; // date is 1 day after today
      case -1:
        return "Eilen"; // date is 1 day before today
      default:
        return "";
    }
  } catch (err) {
    console.error(err);
    return "tänäänHuomennaEilenError";
  }
}
export function viikonpvLong(aika) {
  try {
    if (!isValidDate(aika)) return "";
    const weekday = [
      "Sunnuntai",
      "Maanantai",
      "Tiistai",
      "Keskiviikko",
      "Torstai",
      "Perjantai",
      "Lauantai",
    ];
    const day = weekday[aika.getDay()];
    return day;
  } catch (err) {
    console.log(err);
    return "viikonpvLongError";
  }
}

export function viikonpv(aika, long = false) {
  if (long) return viikonpvLong(aika);
  try {
    if (!isValidDate(aika)) return "";
    const weekday = ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"];
    const day = weekday[aika.getDay()];
    return day;
  } catch (err) {
    console.log(err);
    return "viikonpvError";
  }
}

export function tryJSONparse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error(e);
    return {};
  }
}
export function parse_yyyymmddhhmm(str) {
  if (str == null) return null;
  str = str.toString();
  if (str.length == 8) str = str + "0000";
  // validate year as 4 digits, month as 01-12, and day as 01-31
  if ((str = str.match(/^(\d{4})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])([0-5]\d)$/))) {
    // make a date
    str[0] = new Date(+str[1], +str[2] - 1, +str[3], +str[4], +str[5]);
    // check if month stayed the same (ie that day number is valid)
    if (str[0].getMonth() === +str[2] - 1) {
      return str[0];
    }
  }
  return undefined;
}

export function myReplacer(key, value, obj = null) {
  let keysToReplacePattern = /^(socket|Socket2|auth|isLoading|isBackgroundLoading|accessToken)$/;
  let additionalKeysPattern = "";
  if (obj === "person") {
    additionalKeysPattern = /^(asiakasList|dontAsks|settings)$/;
  }
  if (obj === "keikka") {
    additionalKeysPattern = /^(modules|hinta)$/;
  }
  if (obj === "lasku") {
    additionalKeysPattern = /^(documentData|laskuLog)$/;
  }
  const keysToStartWithReplacePattern = /^(original|handle|token)/;

  if (keysToReplacePattern.test(key) || keysToStartWithReplacePattern.test(key)) {
    return undefined;
  }
  if (additionalKeysPattern && additionalKeysPattern.test(key)) {
    return undefined;
  }

  return value;
  // the above code is the same as the one below
  // if (key == "socket") return undefined;
  // else if (key == "Socket2") return undefined;
  // else if (key == "auth") return undefined;
  // else if (key == "isLoading") return undefined;
  // else if (key == "isBackgroundLoading") return undefined;
  // else if (key == "hinta") return undefined;
  // else if (key.startsWith("original")) return undefined;
  // else if (key.startsWith("handle")) return undefined;
  // else if (key.startsWith("token")) return undefined;
  // else return value;
}
export function getAllVariableNames(obj) {
  try {
    // check if input is a valid object
    if (typeof obj !== "object" || obj === null) {
      throw new Error("Input is not a valid object");
    }
    // remove circular references
    obj = JSON.parse(JSON.stringify(obj, myReplacer));

    let keys = [];
    for (const key in obj) {
      keys.push(key);
      if (typeof obj[key] === "object" && obj[key] !== null) {
        const nestedKeys = getAllVariableNames(obj[key]);
        keys = keys.concat(nestedKeys.map((nestedKey) => key + "." + nestedKey));
      }
    }

    return keys;
  } catch (error) {
    console.error("An error occurred:", error);
    return [];
  }
}

export function timeDiff(start) {
  const end = new Date().getTime();
  return Math.round(end - start);
}

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function firstSecondOfDay(day = new Date()) {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0);
}
export function lastSecondOfDay(day = new Date()) {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999);
}

// run async function with or without await depending on doAwait
export async function doAsync(func, doAwait = true) {
  if (doAwait) return await func();
  return func();
}

let isMobileCached = null;
export function isMobile() {
  if (isMobileCached === null) {
    isMobileCached = /Mobi|Android/i.test(navigator.userAgent);
  }
  return isMobileCached;
}

export function getKbMbGbFromBytes(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
}

export function getGbFromBytes(bytes) {
  return bytes / (1024 * 1024 * 1024);
}

export function betoniLaskutusText(
  betoniToimittajaNimi,
  pumppuToimittajaNimi,
  asiakasNimi,
  isBetoniSuoraLaskutus,
  isPumppuSuoraLaskutus
) {
  let betoniLaskutus = "";
  //  const l = gridKeikka;
  if (isBetoniSuoraLaskutus) {
    betoniLaskutus = betoniToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta betonista";
    if (!isPumppuSuoraLaskutus) betoniLaskutus += " ja pumppauksesta";
  } else {
    betoniLaskutus = betoniToimittajaNimi + " laskuttaa " + pumppuToimittajaNimi + ":ta betonista";
  }
  // set first letter to uppercase
  betoniLaskutus = betoniLaskutus.charAt(0).toUpperCase() + betoniLaskutus.slice(1);
  betoniLaskutus = betoniLaskutus.replace("asiakas:ta", "asiakasta");
  return betoniLaskutus.replace("ja:ta", "jaa");
}
export function pumppuLaskutusText(
  betoniToimittajaNimi,
  pumppuToimittajaNimi,
  asiakasNimi,
  isBetoniSuoraLaskutus,
  isPumppuSuoraLaskutus
) {
  let pumppuLaskutus = "";
  // const l = gridKeikka;
  if (isPumppuSuoraLaskutus) {
    pumppuLaskutus = pumppuToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta pumppauksesta";
    if (!isBetoniSuoraLaskutus) pumppuLaskutus += " ja betonista";
  } else {
    pumppuLaskutus =
      pumppuToimittajaNimi + " laskuttaa " + betoniToimittajaNimi + ":ta pumppauksesta";
  }
  // set first letter to uppercase
  pumppuLaskutus = pumppuLaskutus.charAt(0).toUpperCase() + pumppuLaskutus.slice(1);
  pumppuLaskutus = pumppuLaskutus.replace("asiakas:ta", "asiakasta");
  return pumppuLaskutus.replace("ja:ta", "jaa");
}
// Finnish month names indexed by month number (1-12)
export const finnishMonths = [
  "", // Placeholder for index 0
  "tammikuu", // January
  "helmikuu", // February
  "maaliskuu", // March
  "huhtikuu", // April
  "toukokuu", // May
  "kesäkuu", // June
  "heinäkuu", // July
  "elokuu", // August
  "syyskuu", // September
  "lokakuu", // October
  "marraskuu", // November
  "joulukuu", // December
];

export const getContrastColor = (hexColor) => {
  // if not a valid hex color return black
  if (!/^#[0-9A-F]{6}$/i.test(hexColor)) return "#000000";
  const hex = hexColor.replace("#", "");
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#ffffff";
};

/**
 * Checks if `date2` is the next calendar day after `date1`.
 * @param {Date} date1 - The first date.
 * @param {Date} date2 - The second date.
 * @returns {boolean} - True if `date2` is the next calendar day after `date1`.
 */
export function isNextDay(date1, date2) {
  // Normalize both dates to midnight
  const normalizedDate1 = normalizeToUTC(date1);

  const normalizedDate2 = normalizeToUTC(date2);

  // Calculate the difference in days
  const diffInDays = (normalizedDate2 - normalizedDate1) / (1000 * 60 * 60 * 24);

  return diffInDays === 1;
}

function normalizeToUTC(date) {
  const normalizedDate = new Date(date);
  normalizedDate.setUTCHours(0, 0, 0, 0);
  return normalizedDate;
}
